if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton =
          this.querySelector('[data-ps-atc-button="true"]') || this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        var self = this;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        var formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(function(section) {
              return section.id;
            })
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(this.getCartAddUrl(), config)
          .then(function(response) {
            return response.json();
          })
          .then(function(response) {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              self.handleErrorMessage(response.description);

              var soldOutMessage = self.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              self.submitButton.setAttribute('aria-disabled', true);
              self.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              self.error = true;
              return;
            } else if (!self.cart) {
              window.location = self.getCartUrl();
              return;
            }

            var startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!self.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(function() {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            self.error = false;
            var quickAddModal = self.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                function() {
                  setTimeout(function() {
                    CartPerformance.measure("add:paint-updated-sections", function() {
                      self.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", function() {
                self.cart.renderContents(response);
              });
            }
          })
          .catch(function(e) {
            console.error(e);
          })
          .finally(function() {
            self.submitButton.classList.remove('loading');
            if (self.cart && self.cart.classList.contains('is-empty')) self.cart.classList.remove('is-empty');
            if (!self.error) self.submitButton.removeAttribute('aria-disabled');
            self.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage) {
        if (typeof errorMessage === 'undefined') errorMessage = false;
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      normalizeCartRoute(route, fallback) {
        var value = typeof route === 'string' ? route.replace(/^\s+|\s+$/g, '') : '';
        if (value && value.indexOf('//') === 0) return window.location.protocol + value;
        if (value && (value.charAt(0) === '/' || /^https?:\/\//i.test(value))) return value;
        return fallback;
      }

      getCartAddUrl() {
        var routes = window.routes || {};
        return this.normalizeCartRoute(routes.cart_add_url, '/cart/add.js');
      }

      getCartUrl() {
        var routes = window.routes || {};
        return this.normalizeCartRoute(routes.cart_url, '/cart');
      }

      toggleSubmitButton(disable, text) {
        if (typeof disable === 'undefined') disable = true;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
